import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Quote } from "lucide-react";
import { IMAGES } from "../data/menu";

export default function About() {
  return (
    <main className="bg-[#0A0A0A] pt-[180px]" data-testid="about-page">
      <section className="relative py-24 md:py-32 overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMAGES.bar} alt="Aradela bar" loading="lazy" decoding="async" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/80 to-[#0A0A0A]" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <span className="text-[#D4A017] uppercase tracking-[0.3em] text-xs">Our Story</span>
          <h1 className="font-display text-white text-5xl md:text-7xl mt-4 leading-[0.95] tracking-tight max-w-4xl">
            From <span className="italic font-accent text-[#D4A017]">Lagos kitchens</span> to Milton Keynes tables.
          </h1>
        </div>
      </section>

      <section className="py-16 md:py-24" data-testid="about-story">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-7 space-y-6 text-white/75 text-lg leading-relaxed">
            <p>
              <span className="font-display text-[#D4A017] text-3xl float-left mr-2 leading-none mt-1">
                A
              </span>
              radelá Nigerian Restaurant brings the rich, vibrant flavours of Nigeria to Milton Keynes.
              Every dish is prepared with authentic ingredients, bold spices, and a passion for quality.
            </p>
            <p>
              From classic Jollof Rice to signature Suya, we create meals that feel like home — while delivering a
              premium dining experience that celebrates the heart of West African hospitality.
            </p>
            <p>
              We're more than a restaurant. We're a gathering place. A taste memory. A bold, joyful welcome to anyone
              ready to experience Nigeria — one plate at a time.
            </p>
            <div className="pt-4">
              <Link to="/menu" className="btn-primary" data-testid="about-cta-menu">
                Explore the Menu <ArrowUpRight size={16} />
              </Link>
            </div>
          </div>
          <div className="md:col-span-5">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img src={IMAGES.plating} alt="Plated Nigerian dish" loading="lazy" decoding="async" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#0F0F0F]" data-testid="about-values">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { n: "01", t: "Heritage", d: "Time-honoured recipes, prepared with respect for tradition." },
              { n: "02", t: "Craft", d: "Every spice blend, marinade and stew is built layer by layer." },
              { n: "03", t: "Hospitality", d: "You arrive a guest. You leave family. That's the Aradelá way." },
            ].map((v) => (
              <div
                key={v.n}
                className="bg-[#141414] border border-white/5 p-10 hover:border-[#D4A017]/40 transition-all"
                data-testid={`about-value-${v.n}`}
              >
                <span className="font-display text-[#D4A017]/70 text-5xl">{v.n}</span>
                <h3 className="font-display text-white text-2xl mt-4 mb-3">{v.t}</h3>
                <p className="text-white/55 leading-relaxed">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 relative overflow-hidden" data-testid="about-quote">
        <div
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: `url(${IMAGES.wine})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/40" />
        <div className="relative max-w-4xl mx-auto px-6 md:px-12">
          <Quote className="text-[#D4A017] mb-6" size={36} />
          <p className="font-display text-white text-3xl md:text-5xl leading-tight italic">
            "Bold taste. Rich culture. An unforgettable experience."
          </p>
          <div className="mt-8 flex items-center gap-3">
            <span className="gold-divider" />
            <span className="text-white/60 uppercase tracking-[0.3em] text-xs">The Aradelá Promise</span>
          </div>
        </div>
      </section>
    </main>
  );
}
